export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sima-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "sima-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sima-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "sima-themeWrap" */'./ThemeImporter'),
  },
};
